import React from 'react';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_SQL_AUTOMATIONS } from 'new/constants/pathnames';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ModalMoveToProject } from 'new/elements/ModalMoveToProject';
import { ViewSQLAutomations } from './components/ViewSQLAutomations';

export const SQLAutomations: ScreenComponent<any> = () => {
  return <ViewSQLAutomations />;
};

SQLAutomations.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_SQL_AUTOMATIONS}`,
  domain: 'tasks',
  screenName: 'SQLAutomations',
  modals: [ModalMoveToProject],
  header: {
    title: 'SQL Automations',
    slugTitle: 'SQL Automations',
  },
};
